<template>
  <BaseFormCard ref="display-form-card" width="300" icon="tune">
    <template #title>
      รูปแบบการแสดงผลข้อมูล
    </template>
    <template #body>
      <v-layout pa-4>
        <v-flex xs12 class="d-flex flex-column">
          <v-btn
            :outlined="!btn.isSeverityActive"
            color="primary"
            rounded
            block
            @click="toggleButton('isSeverityActive')"
          >
            <v-icon v-show="btn.isSeverityActive" left>check_circle_outline</v-icon>
            ระดับความรุนแรง</v-btn
          >
          <v-btn
            class="mt-3"
            :outlined="!btn.isVehicleActive"
            color="primary"
            rounded
            block
            @click="toggleButton('isVehicleActive')"
          >
            <v-icon v-show="btn.isVehicleActive" left>check_circle_outline</v-icon>
            ชนิดยานพาหนะ</v-btn
          >
          <v-btn
            class="mt-3"
            :outlined="!btn.isCrashActive"
            color="primary"
            rounded
            block
            @click="toggleButton('isCrashActive')"
          >
            <v-icon v-show="btn.isCrashActive" left>check_circle_outline</v-icon> ลักษณะการชน</v-btn
          >
        </v-flex>
      </v-layout>
    </template>
  </BaseFormCard>
</template>

<script>
import BaseFormCard from './BaseFormCard.vue';

export default {
  name: 'DisplayFormCard',
  components: {
    BaseFormCard
  },
  props: {
    map: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data: () => ({
    btn: {
      isSeverityActive: true,
      isVehicleActive: false,
      isCrashActive: false
    }
  }),
  mounted() {},
  methods: {
    deActivatebtn() {
      this.$refs['display-form-card'].closeClicked();
    },
    toggleButton(clickedKey) {
      Object.keys(this.btn).forEach(key => {
        this.btn[key] = clickedKey === key;
      });
      this.$emit('changePintype', clickedKey);
    }
  },
  computed: {}
};
</script>
<style lang="scss" scoped></style>
